let _ = t => t,
  _t;
import { useContext } from 'react';
import UsageTrackerContext from '../context/UsageTrackerContext';
import { getNavigateToCompanyRecord } from '../constants/events';
import styled from 'styled-components';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import RecordLink from 'crm-links/record/RecordLink';
import styledWithTheme from 'foundations-theming/utils';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRecordLink = styled(RecordLink).withConfig({
  displayName: "CompanyName__StyledRecordLink",
  componentId: "sc-1mvyvp4-0"
})(["@media screen and (max-width:1110px){max-width:150px;}@media screen and (max-width:1500px) and (min-width:1111px){max-width:200px;}@media screen and (max-width:2000px) and (min-width:1501px){max-width:500px;}@media screen and (min-width:2001px){max-width:1150px;}"]);
const StyledLink = styledWithTheme(Link)(_t || (_t = _`
  @media screen and (max-width: 1110px) {
    max-width: 150px;
  }

  @media screen and (max-width: 1500px) and (min-width: 1111px) {
    max-width: 200px;
  }

  @media screen and (max-width: 2000px) and (min-width: 1501px) {
    max-width: 500px;
  }

  @media screen and (min-width: 2001px) {
    max-width: 1150px;
  }
`));
const CompanyName = ({
  associatedCompanyId,
  companyName,
  companyLink,
  external = false,
  includeEschref
}) => {
  const trackEvent = useContext(UsageTrackerContext);
  if (!companyLink) {
    return /*#__PURE__*/_jsx(TruncateString, {
      useFlex: true,
      children: companyName
    });
  }
  if (includeEschref) {
    return /*#__PURE__*/_jsx(StyledRecordLink, {
      "data-test-id": "inbox-header-company-link",
      external: external,
      includeEschref: includeEschref,
      LinkComponentProps: {
        truncate: true,
        truncateStringProps: {
          useFlex: true,
          maxWidth: '8vw'
        },
        ExternalIcon: () => null
      },
      objectId: +associatedCompanyId,
      objectTypeId: "0-2",
      onTrackClick: () => trackEvent(getNavigateToCompanyRecord()),
      children: companyName
    });
  }
  return /*#__PURE__*/_jsx(StyledLink, {
    href: companyLink,
    external: true,
    onClick: () => trackEvent(getNavigateToCompanyRecord()),
    truncate: true,
    truncateStringProps: {
      useFlex: true
    },
    "data-test-id": "inbox-header-company-link",
    children: companyName
  });
};
CompanyName.displayName = 'CompanyName';
export default CompanyName;